module.exports = __webpack_public_path__ + "static/media/c2a5_hg_lebuz.4058df84.wav";